import api from '@pray/shared/utils/api';

export type RefreshAllEmailHealthResponse = {
  message: string;
  refreshed_count: number;
};

export async function refreshAllEmailHealth(): Promise<RefreshAllEmailHealthResponse> {
  const url = '/web/studio/email-health/refresh-all';
  const response = await api.executePostRequest<{ data: RefreshAllEmailHealthResponse }>(url);

  return response.data.data;
}
